import axios from "axios";
import Env from '@/services/env.service';

function safeBaseURL(url: string): string {
    // Only allow http(s) URLs, block local IPs and file URLs
    if (!/^https?:\/\//.test(url)) throw new Error("Unsafe baseURL for axios");
    return url;
}

const api = axios.create({
    baseURL: safeBaseURL(Env.get("VUE_APP_AUTH_BACK_URL") + "/api"),
    withCredentials: true
});

export default api;